// extracted by mini-css-extract-plugin
export var pageWrapperContentStyle = "rsc_hb_page_wrapper-module--pageWrapperContentStyle--lsit+";
export var pageWrapperInnerStyle = "rsc_hb_page_wrapper-module--pageWrapperInnerStyle--QbwOz";
export var pageWrapperOuterStyle = "rsc_hb_page_wrapper-module--pageWrapperOuterStyle--gfnv9";